import React from "react";
import Images from "../Constants/Images";
import { useTranslation } from "react-i18next";
import Colors from "../Constants/Color";
import CustomBanner from "../Components/CustomBanner/CustomBanner";
import Icons from "../Constants/Icons";
import ScrollAnimation from "react-animate-on-scroll";
const bannerdata = [
  {
    Name: "Discover the Full",
    NameTwo: "Potential of Your Property",
    Title: "KŌZĒ is the missing key needed to unlock the full potential",
    TitleTwo: "of your property.",
    Bannerimg: Images.AboutBanner,
  }
]
const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div style={{ backgroundColor: Colors.lightgoladn }} className="About_us" >

      <CustomBanner bannerdata={bannerdata} />
      <div
        style={{ backgroundColor: Colors.lightgoladn }}
        className="pt-12 home_away py-10"
      >
        <div className="container">
          <div className="mt-10 overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <img
                      style={{ overflowClipMargin:"unset" }}
                      src={Images.About}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%]"
                    />
                  </ScrollAnimation>
                </div>

                <div  className="w-full md:w-1/2 mt-4">
                  <ScrollAnimation animateIn="bounceInRight">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Our Mission")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t("We believe that every stay should be both effortless and")}<br /><span className='showbr'></span>
                      {t("exceptional. We are redefining property management by")}<br /><span className='showbr'></span>
                      {t("combining hassle-free, profitable solutions for owners")}<br /><span className='showbr'></span>
                      {t("while creating unforgettable, 5-star experiences")}<br /><span className='showbr'></span>
                      {t("for guests that will keep them coming back for more!")}<br /><span className='showbr'></span>
                    </p>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black py-10">
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">

                <div  className="w-full md:w-1/2 mt-4 text-white">
                  <ScrollAnimation animateIn="bounceInLeft">

                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("How We Got Started")}
                    </div>

                    <p className="text-left Optima collapse_txte font-24">
                      {t("Our journey began with a simple goal: to elevate the property")}<br /><span className='showbr'></span>
                      {t("management experience while ensuring guests enjoy a premium")}<br /><span className='showbr'></span>
                      {t("stay. Over time, our founder, Jeffery Khoury, developed innovative")}<br /><span className='showbr'></span>
                      {t("strategies that set the stage for our success, transforming the way")}<br /><span className='showbr'></span>
                      {t("properties are managed and enjoyed.")}
                    </p>
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInRight">
                    <img
                      src={Images.About1}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "black" }} className="my-0 max-[767px]:py-0 relative">
        <img src={Images.About2} className="w-full m" />
        <img src={Icons.tray_angle} className="absolute right-0 top-0 max-[767px]:w-7" />
      </div>
      <div className="bg-black py-10">
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <img
                      src={Images.About3}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
                <div  className="w-full md:w-1/2 grid items-center text-white ">
                  <div>
                    <ScrollAnimation animateIn="bounceInRight">
                      <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                        {t("KŌZĒ Today")}
                      </div>
                      <p className="text-left Optima collapse_txte font-24">
                        {t("We are now a leader in property management across 30 cities")}<br /><span className='showbr'></span>
                        {t("around the world, known for our exceptional and flexible services,")}<br /><span className='showbr'></span>
                        {t("as well as our competitive rates. Our dedicated team ensures that")}<br /><span className='showbr'></span>
                        {t("every property in our portfolio thrives, and exceeds its maximum")}<br /><span className='showbr'></span>
                        {t(" potential, while ensuring that our guests have the most memorable")}<br /><span className='showbr'></span>
                        {t("and comfortable stay.")}<br /><span className='showbr'></span>
                      </p>
                      <ul className="mt-8 ml-5 block" style={{ listStyle: "inherit" }}>
                        <li className="Optima  font-24">{t("30+ cities worldwide")}</li>
                        <li className="Optima  font-24">{t("150+ properties globally")}</li>
                      <li className="Optima  font-24">{t("200+ reservations per week")}</li>

                      </ul>
                    </ScrollAnimation>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ backgroundColor: Colors.lightgoladn }}
        className="pt-12 home_away py-16"
      >
        <div className="container">
          <div className="mt-10 overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div  className="w-full md:w-1/2 mt-4">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Where We Are Going")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t("The sky is the limit! We are constantly expanding our portfolio")}<br /><span className='showbr'></span>
                      {t("with new and unique properties in different cities around the")}<br /><span className='showbr'></span>
                      {t(" world. Stay tuned to see where KŌZĒ is heading next!")}<br /><span className='showbr'></span>
                    </p>
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInRight">
                    <img
                      src={Images.About4}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutUs;
